import React from "react";
import { Button } from "../../components";

const SellingProduct = (props: any) => {
  const { updateProductQuantityOnAction, sellingProducts, setProductQuantity, productQuantity, sellData } = props
  return (
    <div className="table-responsive">
      <table className="table align-middle fs-7">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Product</th>
            <th>Available Qty.</th>
            <th>Selling Price</th>
            <th>Qty</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {Object.values(sellingProducts)?.map(
            (item: any, index: number) => {
              return (
                <tr key={item?.id}>
                  <td>{index + 1}</td>
                  <td>{item?.name}</td>
                  <td>{item?.availableQuantity}</td>
                  <td>{item?.sellingPrice}</td>
                  <td>
                    <div className="quantity-input">
                      <Button
                        className="minus"
                        bname="-"
                        name="minus"
                        id="minus"
                        onClick={() =>
                          setProductQuantity((_oldData: any) => ({
                            ..._oldData,
                            [item?.id]:
                              productQuantity[item?.id] > 0 ? productQuantity[item?.id] - 1 : 0
                            ,
                          }))
                        }
                      >
                        -
                      </Button>
                      <input
                        type="text"
                        className="form-control"
                        style={{ width: "50px" }}
                        id="quantity"
                        value={Number(productQuantity[item?.id]) || 0}
                        onChange={(e: any) =>
                          e.target.value <= sellData[item.id]?.availableQuantity && setProductQuantity((_oldData: any) => ({
                            ..._oldData,
                            [item?.id]: e.target.value
                          }))
                        }
                      />
                      <Button
                        className="plus"
                        bname="+"
                        id="plus"
                        name="plus"
                        onClick={() =>
                          setProductQuantity((_oldData: any) => ({
                            ..._oldData,
                            [item?.id]:
                              productQuantity[item?.id] < sellData[item.id]?.availableQuantity ? Number(productQuantity[item?.id]) + 1 : sellData[item.id]?.availableQuantity
                          }))
                        }
                      >
                        +
                      </Button>
                    </div>
                  </td>
                  <td className="text-nowrap">
                    <Button
                      onClick={() =>
                        updateProductQuantityOnAction(item?.id)
                      }
                      bname="Add to Cart"
                      id="addtocart"
                      name="addtocart"
                      className="btn btn-sm btn-primary"
                    ></Button>
                  </td>
                </tr>
              );
            }
          )}
        </tbody>
      </table>
    </div>
  )
}

export { SellingProduct }